// extracted by mini-css-extract-plugin
export var backgroundImage = "PageNotFound-module--backgroundImage--8ca2c";
export var title = "PageNotFound-module--title--336c5";